import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP103_Request,
  IAPI_APP103_Response,
} from "../../../type/apiType";

// 要処理一覧　担当者更新
// API仕様書_要処理対応
const httpAPI_APP103 = async (
  param: IAPI_APP103_Request
): Promise<IAPI_APP103_Response> => {
  let res = await http.post(ApiUrl.API_APP103, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP103 };
